import { cx } from '@linaria/core';
import { useRef } from 'react';
import { generateValueId } from '@utils/common';
import { useTruncatedState } from '@utils/react';
import { cellContent, cell } from './cell.style.js';
import { jsx } from 'react/jsx-runtime';
import { Tooltip } from '../overlays/tooltip/tooltip.js';

function Cell(props) {
  const contentRef = useRef(null);
  const isTruncated = useTruncatedState(contentRef, generateValueId(props.children));
  const disableTooltip = typeof props.tooltip === "boolean" && !props.tooltip;
  return /*#__PURE__*/jsx(Tooltip, {
    disabled: disableTooltip || !isTruncated,
    placement: "top",
    body: props.tooltip ?? props.children,
    mountIn: document.body,
    ariaType: undefined,
    children: ref => /*#__PURE__*/jsx("div", {
      ref: ref,
      "aria-label": props["aria-label"],
      "aria-hidden": props["aria-hidden"],
      role: props.role === "unset" ? undefined : props.role ?? "cell",
      className: cx(cell, props.className),
      children: /*#__PURE__*/jsx("div", {
        ref: contentRef,
        className: cx(cellContent, props.role),
        children: props.children
      })
    })
  });
}

export { Cell };
//# sourceMappingURL=cell.js.map
